import React from 'react';
import { Card, Stack, Typography } from '@mui/material';

type TicketNotesTabProps = {
  notes: string[];
};

const TicketNotesTab: React.FC<TicketNotesTabProps> = ({ notes }) => (
  <Card sx={{ p: 3 }}>
    <Typography variant="h6" sx={{ mb: 2 }}>
      Latest Notes
    </Typography>
    <Stack spacing={2}>
      {notes.map((note, index) => (
        <Stack
          key={`note-${index}`}
          spacing={0.5}
          sx={{ borderLeft: (theme) => `3px solid ${theme.palette.primary.main}`, pl: 2 }}
        >
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
            Note {index + 1}
          </Typography>
          <Typography variant="body2">{note}</Typography>
        </Stack>
      ))}
    </Stack>
    {notes.length === 0 && (
      <Typography variant="body2" color="text.secondary">
        No notes have been added yet.
      </Typography>
    )}
  </Card>
);

export default TicketNotesTab;
